var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttribute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.031 1.625c.362 0 .657.294.657.656V16.72a.657.657 0 01-.657.656H1.97a.657.657 0 01-.657-.656V2.28c0-.362.295-.656.657-.656H19.03zm0-1.313H1.97A1.969 1.969 0 000 2.282v14.437c0 1.087.881 1.968 1.969 1.968H19.03A1.969 1.969 0 0021 16.72V2.28A1.969 1.969 0 0019.031.312zM5.25 4.25a1.313 1.313 0 100 2.625 1.313 1.313 0 000-2.625zm0 3.938a1.313 1.313 0 100 2.625 1.313 1.313 0 000-2.626zm0 3.937a1.312 1.312 0 100 2.625 1.312 1.312 0 000-2.625zm11.813-6.07V5.07a.246.246 0 00-.247-.246H8.121a.246.246 0 00-.246.246v.985a.246.246 0 00.246.246h8.695a.246.246 0 00.247-.246zm0 3.937v-.984a.246.246 0 00-.247-.246H8.121a.246.246 0 00-.246.246v.984a.246.246 0 00.246.246h8.695a.246.246 0 00.247-.246zm0 3.938v-.985a.246.246 0 00-.247-.246H8.121a.246.246 0 00-.246.246v.985a.246.246 0 00.246.246h8.695a.246.246 0 00.247-.246z",
    fill: "#3952FA"
  })));
}

export default __webpack_public_path__ + "./fonts/attribute.6e5fb994fce1e14f0ef85e5e08f3f854.svg";
export { SvgAttribute as ReactComponent };